function pickHeadline(form) {
    if (form.businessName && form.industry) {
        return `${form.businessName} — ${form.industry} website experience`;
    }

    if (form.businessName) {
        return `${form.businessName} — premium website preview`;
    }

    return "Your AI-generated website preview starts here";
}

function pickSubtitle(form) {
    if (form.description?.trim()) {
        return form.description;
    }

    if (form.industry) {
        return `A premium, conversion-focused ${form.industry.toLowerCase()} website experience built with Shriansh Nexus.`;
    }

    return "Business-first structure, premium UI, and an instant preview flow designed for faster launch.";
}

export default function GeneratorHeroPreview({ form }) {
    const pages = Array.isArray(form.pages) ? form.pages.slice(0, 4) : [];

    return (
        <div className="wg-hero-preview">
            <div className="wg-hero-preview-copy">
                <div className="wg-hero-preview-badge">Live Generator Preview</div>

                <h3 className="wg-hero-preview-title">{pickHeadline(form)}</h3>

                <p className="wg-hero-preview-subtitle">{pickSubtitle(form)}</p>

                <div className="wg-hero-preview-actions">
                    <button type="button" className="wg-btn primary" disabled>
                        Primary CTA
                    </button>
                    <button type="button" className="wg-btn secondary" disabled>
                        Secondary CTA
                    </button>
                </div>

                <div className="wg-hero-preview-tags">
                    <span>{form.industry || "Industry"}</span>
                    <span>{form.goalOfWebsite || "Goal"}</span>
                    <span>{form.brandStyle || "Brand Style"}</span>
                </div>
            </div>

            <div className="wg-hero-preview-visual">
                <div className="wg-hero-preview-window">
                    <div className="wg-hero-preview-topbar">
                        <span />
                        <span />
                        <span />
                    </div>

                    <div className="wg-hero-preview-body">
                        <div className="wg-hero-preview-sidebar">
                            <div />
                            <div />
                            <div />
                            <div />
                        </div>

                        <div className="wg-hero-preview-main">
                            <div className="wg-hero-preview-main-hero" />
                            <div className="wg-hero-preview-main-grid">
                                <div />
                                <div />
                                <div />
                            </div>

                            {pages.length > 0 && (
                                <div className="wg-hero-preview-page-row">
                                    {pages.map((page) => (
                                        <span key={page}>{page}</span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}